import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePageViewTracking } from '@/hooks/usePageViewTracking';

export function ScrollToTop() {
  const { pathname } = useLocation();

  usePageViewTracking();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
